import { Iconify } from 'src/components/iconify';

import { paths } from 'src/routes/paths';

export const _account = [
  {
    label: 'Dashboard',
    href: paths.dashboard.root,
    icon: <Iconify icon="solar:widget-2-bold-duotone" />,
  },
  {
    label: 'Profile',
    href: paths.dashboard.account.profile,
    icon: <Iconify icon="solar:user-bold-duotone" />,
  },
  {
    label: 'Account Settings',
    href: paths.dashboard.account.settings,
    icon: <Iconify icon="solar:settings-bold-duotone" />,
  },
];
